<script setup lang="ts">
import {computed} from 'vue'
import {WorkflowGroupStore} from '@/branchmanager/app/workspace/workflowGroupStore.ts'
import {useLDFlag} from 'launchdarkly-vue-client-sdk'

const props = defineProps<{
  defaultHeading: string
}>()

const ldFlag = useLDFlag("open-anywhere-employee-channel-custom-workflows", false)

const text = computed(() =>
  ldFlag.value && WorkflowGroupStore().workspaceGroup?.workflowGroupName
    ? WorkflowGroupStore().workspaceGroup?.workflowGroupName
    : props.defaultHeading
)
</script>

<template>
  <div class="jh-font-heading-medium-3">
    {{ text }}
  </div>
</template>

<style scoped>
@import '../../../assets/typography.css';
</style>
